module.exports = __webpack_public_path__ + "static/media/Book With_Button_Rounded.e0e322e2.svg";